import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const FETCH_HERO_TRUCK_BY_ID_REQUEST =
  'HeroTurck/FETCH_HERO_TRUCK_BY_ID_REQUEST'
const FETCH_HERO_TRUCK_BY_ID_SUCCESS =
  'HeroTurck/FETCH_HERO_TRUCK_BY_ID_SUCCESS'
const FETCH_HERO_TRUCK_BY_ID_FAILURE =
  'HeroTurck/FETCH_HERO_TRUCK_BY_ID_FAILURE'

const FETCH_HERO_TRUCK_ALL_REQUEST =
  'HeroTurck/FETCH_HERO_TRUCK_ALL_REQUEST'
const FETCH_HERO_TRUCK_ALL_SUCCESS =
  'HeroTurck/FETCH_HERO_TRUCK_ALL_SUCCESS'
const FETCH_HERO_TRUCK_ALL_FAILURE =
  'HeroTurck/FETCH_HERO_TRUCK_ALL_FAILURE'

// Initialize State
const initialState = {
  isLoading: true,
  error: {},
  heroTruck: {},
  heroTruckList: {},
}

// Default Reducer
const heroTurck = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_HERO_TRUCK_ALL_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_HERO_TRUCK_ALL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        heroTruckList: action.payload
      }
    case FETCH_HERO_TRUCK_ALL_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_HERO_TRUCK_BY_ID_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_HERO_TRUCK_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        heroTruck: action.payload
      }
    case FETCH_HERO_TRUCK_BY_ID_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    default:
      return state
  }
}

export default heroTurck

// Action Creators
export const fetchHeroTruckList = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_HERO_TRUCK_ALL_REQUEST
      })

      const { data } = await API.get(EndPoints.TRUCK + `/all`)
      const typeList = data.map(item => item.type)
        .filter((value, index, self) => self.indexOf(value) === index)
      const arr = []
        for (const item of typeList) {
            arr.push({ text: item, value: item })
        }
      const resultList = {
        data : data,
        typeList: arr
      }
      dispatch({
        type: FETCH_HERO_TRUCK_ALL_SUCCESS,
        payload: resultList
      })
    } catch (err) {
      dispatch({
        type: FETCH_HERO_TRUCK_ALL_FAILURE
      })
    }
  }
}

export const getHeroTruckById = (heroId) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_HERO_TRUCK_BY_ID_REQUEST
      })
      const { data } = await API.get(EndPoints.TRUCK + `/hero/${heroId}`)
      const typeList = data.map(item => item.type)
      .filter((value, index, self) => self.indexOf(value) === index)
    const arr = []
      for (const item of typeList) {
          arr.push({ text: item, value: item })
      }
    const resultList = {
      data : data,
      typeList: arr
    }
      dispatch({
        type: FETCH_HERO_TRUCK_BY_ID_SUCCESS,
        payload: resultList
      })
    } catch (err) {
      dispatch({
        type: FETCH_HERO_TRUCK_BY_ID_FAILURE
      })
    }
  }
}
